import { Heading, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { CircularGradientList } from 'components/icons/circular-gradient';
import ShareFormTextarea from 'components/ShareForm/ShareFormTextarea';
import { YOUTUBE_PLAYLIST_NAME_MAX_CHARS } from 'constants/social';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import YoutubeVisibilitySelector from 'containers/YoutubePostModal/YoutubeVisibilitySelector';
import { YoutubeVideoVisibility } from 'types';
import { socialShareModalBlock as block } from '../../../../utils';

export type YouTubeCreatePlaylistStepProps = {
  isCreatingPlaylist: boolean;
  playlistName: string;
  visibility: YoutubeVideoVisibility;
  onPlaylistNameChange: (value: string) => void;
  onVisibilityChange: (value: YoutubeVideoVisibility) => void;
};

const YouTubeCreatePlaylistStep: React.FC<YouTubeCreatePlaylistStepProps> = ({
  isCreatingPlaylist,
  playlistName,
  visibility,
  onPlaylistNameChange,
  onVisibilityChange,
}) => {
  return (
    <SocialShareModalBody
      showRegenerateTextButton={false}
      isLoading={isCreatingPlaylist}
      loadingTitle="Creating playlist"
    >
      <Spacer
        orientation="vertical"
        justify="center"
        align="center"
        space="24px"
        className={block('step-contents-container')}
      >
        <CircularGradientList className={block('step-main-icon')} />

        <Heading level={2} size="24px">
          Create a new playlist
        </Heading>

        <Spacer
          orientation="vertical"
          justify="center"
          align="center"
          space="16px"
          className={block('step-contents-container')}
        >
          <ShareFormTextarea
            type="input"
            label="Playlist title"
            placeholder="Add title"
            maxChars={YOUTUBE_PLAYLIST_NAME_MAX_CHARS}
            value={playlistName}
            onChange={onPlaylistNameChange}
          />

          <YoutubeVisibilitySelector
            value={visibility}
            onChange={onVisibilityChange}
          />
        </Spacer>
      </Spacer>
    </SocialShareModalBody>
  );
};

export default YouTubeCreatePlaylistStep;
